module.exports = __webpack_public_path__ + "img/t4-i12-1.fec0bcaf.svg";